import React from "react";

import styles from "../styles/payment-on-delivery.module.scss";

import { Title } from "../shared/components/Title";
import { Drawer } from "../shared/components/Drawer";
import { Select } from "../shared/components/Select";
import { Button } from "../shared/components/Button";
import { Icon } from "../shared/components/core/Icon";
import { Checkbox } from "../shared/components/Checkbox";
import { Add } from "../shared/components/Add";

import {
    PaymentMethod,
    Method as AvailableMethods,
    Method,
} from "../shared/utils/Payment";

import { EnvironmentsAPI } from "../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";
import { PaymentGroup } from "../shared/utils/PaymentOnDelivery/PaymentGroup";

const defaultPaymentGroups = {
    CREDIT: [
        { name: "Visa", alias: "VISA", active: true, index: 0 },
        { name: "Mastercard", alias: "MASTERCARD", active: true, index: 1 },
        { name: "Hiper", alias: "HIPER", active: true, index: 2 },
        { name: "Elo", alias: "ELO", active: false, index: 3 },
        {
            name: "American Express",
            alias: "AMERICAN_EXPRESS",
            active: false,
            index: 4,
        },
    ],
    DEBIT: [
        { name: "Visa", alias: "VISA", active: true, index: 0 },
        { name: "Mastercard", alias: "MASTERCARD", active: true, index: 1 },
        { name: "Hiper", alias: "HIPER", active: true, index: 2 },
        { name: "Elo", alias: "ELO", active: false, index: 3 },
    ],
    MEAL_VOUCHER: [
        { name: "Alelo", alias: "ALELO_REFEICAO", active: false, index: 0 },
        { name: "VR", alias: "VR_REFEICAO", active: false, index: 1 },
        { name: "Sodexo", alias: "SODEXO_REFEICAO", active: false, index: 2 },
    ],
    FOOD_VOUCHER: [
        { name: "Alelo", alias: "ALELO_ALIMENTACAO", active: false, index: 0 },
        { name: "VR", alias: "VR_ALIMENTACAO", active: false, index: 1 },
        {
            name: "Sodexo",
            alias: "SODEXO_ALIMENTACAO",
            active: false,
            index: 2,
        },
    ],
    MONEY: [{ name: "Dinheiro", alias: "DINHEIRO", active: false, index: 0 }],
};

export default class PaymentOnDelivery extends React.Component {
    state = {
        open: false,
        saveLoading: false,
        selectedFlag: "",
        activePaymentGroup: null,
        paymentsGroups: [],
        selectedMethods: [],
        groups: [],
        activeMethods: [],
        allMethods: defaultPaymentGroups,
    };

    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        const response = await EnvironmentsAPI.getConfigurationsPaymentMethods(
            EnvironmentStorage.getSelectedEnvironment()
        );
        const configurations = response || {};
        this.refreshMethods(configurations || {});

    }

    async refreshMethods({ payment_methods }) {
        const pgCredit = new PaymentGroup(
            "Crédito",
            "CREDIT",
            PaymentMethod.CREDIT,
            this.state.allMethods.CREDIT,
            payment_methods || []
        );
        const pgDebit = new PaymentGroup(
            "Débito",
            "DEBIT",
            PaymentMethod.DEBIT ,
            this.state.allMethods.DEBIT,
            payment_methods || []
        );
        const pgDinner = new PaymentGroup(
            "Voucher Refeição",
            "MEAL_VOUCHER",
            PaymentMethod.MEAL | PaymentMethod.VOUCHER,
            this.state.allMethods.MEAL_VOUCHER,
            payment_methods || []
        );
        const pgFood = new PaymentGroup(
            "Voucher Alimentação",
            "FOOD_VOUCHER",
            PaymentMethod.FOOD | PaymentMethod.VOUCHER,
            this.state.allMethods.FOOD_VOUCHER,
            payment_methods || []
        );
        const pgMoney = new PaymentGroup(
            "Dinheiro",
            "MONEY",
            PaymentMethod.MONEY,
            this.state.allMethods.MONEY,
            payment_methods || []
        );
          this.setState({
            allMethods: {
              CREDIT: pgCredit.flags,
              DEBIT: pgDebit.flags,
              MEAL_VOUCHER: pgDinner.flags,
              FOOD_VOUCHER: pgFood.flags,
              MONEY: pgMoney.flags,
            }
          })
        this.setState({
            activeMethods: payment_methods || [],
            groups: [pgCredit, pgDebit, pgDinner, pgFood, pgMoney],
        });
    }

    async setStateAsync(data) {
        return new Promise((resolve) => this.setState(data, resolve));
    }

    async save() {
        const { activeMethods } = this.state;

        const environmentId = EnvironmentStorage.getSelectedEnvironment();
        const payload = activeMethods.map((m) => ({
            alias: m.alias,
            type: m.type,
            name: m.name,
            active: true,
        }));

        await this.setStateAsync({ saveLoading: true });

        const response =
            await EnvironmentsAPI.putConfigurationsPaymentMethodsByEnvironmentId(
                environmentId,
                payload
            );
        if (response.getErrors([]).length > 0) {
            alert({
                text: `Não foi possível salvar os métodos de pagamento: ${
                    response.getErrors()[0]
                }`,
            });
        } else {
            alert({ text: `Salvo com sucesso` });
        }

        await this.setStateAsync({ saveLoading: false });
    }

    openPaymentMethodDrawer(method) {
        this.setState({
            activePaymentGroup: method,
            open: true,
        });

        this.setState({
            selectedFlag: this.getAvailableFlags(method)?.[0]?.value
        });
    }

    getAvailableFlags(method) {
        const { activePaymentGroup, activeMethods } = this.state;

        const selectedPaymentGroup = method || activePaymentGroup

        if (!selectedPaymentGroup) {
            return [];
        }

        const activePaymentType = selectedPaymentGroup.type;
        const activePaymentAlias = selectedPaymentGroup.alias;

        const availableMethods = Object.values(Method).filter((m) =>
            PaymentGroup.typeIs(m.type, activePaymentType)
        );
        const alreadyNotSelectedMethods = availableMethods.filter((a) => {
            return !activeMethods.find(
                (activeMethod) =>
                    activeMethod.alias == a.alias &&
                    PaymentGroup.typeIs(activeMethod.type, activePaymentType)
            );
        });

        const defaultAliases = this.state.allMethods[activePaymentAlias].map(
            (m) => m.alias
        );
        const finalStage = alreadyNotSelectedMethods.filter(
            (i) => !defaultAliases.includes(i.alias)
        );

        return finalStage.map((f) => ({ value: f.alias, label: f.name }));
    }

    getPaymentGroupByAlias(alias) {
        const { paymentsGroups } = this.state;
        return paymentsGroups.find((pg) => pg.alias == alias);
    }

    getPaymentGroupIndexByAlias(alias) {
        const { paymentsGroups } = this.state;
        return paymentsGroups.findIndex((pg) => pg.alias == alias);
    }

    addNewFlag() {
      const { activePaymentGroup, selectedFlag, allMethods } = this.state;
      
      const flagInfo = Method[selectedFlag];
      const newFlag = {
        name: flagInfo.name,
        alias: selectedFlag,
        active: false, 
        index: allMethods[activePaymentGroup.alias] ? allMethods[activePaymentGroup.alias].length : 0 
      };
    
      this.setState({
        allMethods: {
          ...allMethods,
          [activePaymentGroup.alias]: [
            ...(allMethods[activePaymentGroup.alias] || []),
            newFlag,
          ],
        },
        activePaymentGroup: null,
        selectedFlag: null,
        open: false,
      });
    
      this.onClickFlag(activePaymentGroup.type, selectedFlag);
    }
    

    onClickFlag(groupType, flagAlias) {
        const { activeMethods } = this.state;

        const flagSelected = activeMethods.find((f) => f.alias == flagAlias);
        if (!flagSelected) {
            activeMethods.push({
                name: Method[flagAlias].name,
                alias: flagAlias,
                type: 0,
            });
        }

        for (const method of activeMethods) {
            if (method.alias != flagAlias) {
                continue;
            }

            method.type = (method.type ^ groupType) | PaymentMethod.FISICO;
            break;
        }

        this.refreshMethods({
            payment_methods: activeMethods,
        });
    }

    render() {
        const { open, saveLoading, groups } = this.state;

        const environment = EnvironmentStorage.getEnvironment();

        function getSubtitle() {
            if (environment?.brand)
                return `${environment.brand.name} - ${environment.name}`;
            return environment?.name;
        }

        return (
            <div className={styles.paymentOnDeliveryContainer}>
                <Title
                    title="Pagamento na entrega"
                    subtitle={getSubtitle()}
                    backTo={{ url: "/configuracoes", name: "Configurações" }}
                />

                <div className={styles.paymentsMethodsContainer}>
                    {groups.map((group, _i) => {
                        return (
                            <div className={styles.paymentsGroups} key={_i}>
                                <p className={styles.paymentMethodName}>
                                    {group.name}
                                </p>
                                <div className={styles.methods}>
                                    {group.flags.map((flag, index) => {
                                        return (
                                            <div
                                                className={styles.method}
                                                key={index}
                                                onClick={() =>
                                                    this.onClickFlag(
                                                        group.type,
                                                        flag.alias
                                                    )
                                                }
                                            >
                                                <img
                                                    src={`${process.env.REACT_APP_ASSETS_URL}/cards/${flag.alias}.png`}
                                                    onError={({
                                                        currentTarget,
                                                    }) => {
                                                        currentTarget.onerror =
                                                            null; // prevents looping
                                                        currentTarget.src = `${process.env.REACT_APP_ASSETS_URL}/cards/DEFAULT.png`;
                                                    }}
                                                    alt={flag.alias}
                                                    className={styles.flagImage}
                                                />
                                                <Checkbox
                                                    name={`${flag.name}-${group.type}`}
                                                    checked={flag.active}
                                                    design="two"
                                                >
                                                    {flag.name}
                                                </Checkbox>
                                            </div>
                                        );
                                    })}
                                    {group.type !==
                                        (PaymentMethod.FISICO |
                                            PaymentMethod.MONEY) && (
                                        <Add
                                            text="Adicionar bandeira"
                                            onClick={() =>
                                                this.openPaymentMethodDrawer({
                                                    type: group.type,
                                                    alias: group.alias,
                                                })
                                            }
                                        />
                                    )}
                                </div>
                            </div>
                        );
                    })}

                    <div className={styles.save}>
                        <Button
                            design="primary"
                            onClick={() => this.save()}
                            loading={saveLoading}
                            disabled={saveLoading}
                            className="w-100"
                        >
                            Salvar
                        </Button>
                    </div>
                </div>

                <Drawer
                    visible={open}
                    title="Adicionar bandeira"
                    onClose={() => this.setState({ open: false })}
                    footer={
                        <Button
                            design="primary"
                            className="w-100"
                            onClick={() => this.addNewFlag()}
                        >
                            Adicionar
                        </Button>
                    }
                >
                    <Select
                        label="Bandeira"
                        onChange={(e) =>
                            this.setState({ selectedFlag: e.target.value })
                        }
                        options={this.getAvailableFlags()}
                    />
                </Drawer>
            </div>
        );
    }
}
